import { render, staticRenderFns } from "./reagister.vue?vue&type=template&id=37aeb5e4&scoped=true&"
import script from "./reagister.vue?vue&type=script&lang=ts&"
export * from "./reagister.vue?vue&type=script&lang=ts&"
import style0 from "./reagister.vue?vue&type=style&index=0&id=37aeb5e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aeb5e4",
  null
  
)

export default component.exports